import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { WAS_AUTHED_KEY } from '~/Auth'
import { AppShell } from '~/components/blocks/AppScene/AppShell'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context }) => {
    if (!context.session.data) {
      // Offline, the session endpoint is unreachable. Let previously-authenticated
      // users through to their downloaded music instead of bouncing to sign-in.
      const offlineAllowed = !navigator.onLine && localStorage.getItem(WAS_AUTHED_KEY) === '1'
      if (!offlineAllowed) throw redirect({ to: '/sign-in' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
